module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "col-xs-12 block obj-cont corte ivitamos"
  }, [_c('img', {
    staticClass: "obj-img",
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row flex-centermid"
  }, [_c('h2'), _vm._v(" "), _c('a', {
    staticClass: "btn gradient",
    attrs: {
      "href": ""
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-550dbd16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/img_linkportada.vue
// module id = 133
// module chunks = 0